import React, { FC, ReactNode } from "react";
import * as S from "./Styles";

// TextList
export interface TextListProps {
  /**
   * List content.
   */
  children?: ReactNode;

  /**
   * Optional classname.
   */
  className?: string;

  /**
   * Set max-width on list container in pixels.
   */
  maxWidth?: number;
}

export const TextList: FC<TextListProps> = ({ children, className, maxWidth }) => {
  return (
    <S.List className={className} maxWidth={maxWidth}>
      {children}
    </S.List>
  );
};

// TextListItem
export interface TextListItemProps {
  children: ReactNode;
  className?: string;
}

export const TextListItem: FC<TextListItemProps> = ({ children, className }) => {
  return <S.Item className={className}>{children}</S.Item>;
};

export default TextList;
